/** @typedef {import("../types").InfoNode} InfoNode */

export const ROOT_PARENT = "root";
export const ROOT_DROP_ZONE_ID = "root-drop-zone";
export const ROOT_START_DROP_ZONE_ID = "root-start-drop-zone";
export const ROOT_END_DROP_ZONE_ID = "root-end-drop-zone";
export const NESTED_PADDING = 80;

/**
 * Normalize a node so parent/type defaults are always set.
 * This in for legacy cases, where a node might not have a parentId / type (pre-folder era)
 * @param {Partial<InfoNode>} node - Node coming from API or optimistic state.
 * @returns {InfoNode} Normalized node with guaranteed type and parentId.
 */
export function normalizeNode(node) {
	return {
		...node,
		type: node.type || "page",
		parentId: node.parentId || ROOT_PARENT,
	};
}

/**
 * Finds the container id that currently owns a node id.
 * Returns the node id itself when it represents a  folder
 * @param {Record<string, string[]>} items - Mapping of container -> ordered node ids.
 * @param {string | null | undefined} nodeId - The node we're searching for.
 * @returns {string | null}
 */
export function findContainer(items, nodeId) {
	if (!nodeId) {
		return null;
	}

	if (Object.prototype.hasOwnProperty.call(items, nodeId)) {
		return nodeId;
	}

	for (const [containerId, containerItems] of Object.entries(items)) {
		if (containerItems.includes(nodeId)) {
			return containerId;
		}
	}

	return null;
}
